export const INITIAL_IMPORT_ACTIVE_POLL_INTERVAL_MS = 5000;
export const INITIAL_IMPORT_IDLE_POLL_INTERVAL_MS = 30000;
